import React, { Component } from 'react';
import { Route, RouteProps } from 'react-router-dom';

import { isFeatureEnabled, Features } from '../features';

interface IProtectedRoute extends RouteProps {
  inFeatures: ReadonlyArray<Features>;
}

class RouteIncluded extends Component<IProtectedRoute> {
  render(): JSX.Element | null {
    const { inFeatures, children, ...props } = this.props;
    const shouldRender = inFeatures.some(targetFeature => isFeatureEnabled(targetFeature));

    if(!shouldRender) {
      return null;
    }

    return (
      <Route {...props} >{children}</Route>
    );
  }
}

class RouteExcluded extends Component<IProtectedRoute> {
  render(): JSX.Element | null {
    const { inFeatures, children, ...props } = this.props;
    const shouldRender = inFeatures.every(targetFeature => !isFeatureEnabled(targetFeature));

    if(!shouldRender) {
      return null;
    }

    return (
      <Route {...props} >{children}</Route>
    );
  }
}

export const DummyComponent: React.FC<{text: string}> = (props) => <div>Dummy component {props.text}</div>;

export { RouteIncluded, RouteExcluded };
